<template>
  <section v-if="isNotAnEmployee && route.name !== 'Gift Card'">
    <div v-if="orderTypesEnabled && showOTSwitcher">
      <WCMobileOTSwitcher />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { useRoute } from 'vue-router';
import useOrderTypes from '@/composables/useOrderTypes';
import WCMobileOTSwitcher from '@/components/WCMobileOTSwitcher/WCMobileOTSwitcher.vue';
import useEmployee from '@/modules/employee/composables/useEmployee';
import { configurationKey } from '@/injections';

const { isNotAnEmployee } = useEmployee();
const route = useRoute();
const { visibleOrderTypes } = useOrderTypes();
const configuration = inject(configurationKey);
const orderTypesEnabled = computed(() => configuration?.orderTypesEnabled);
const showOTSwitcher = computed(() => (visibleOrderTypes.value?.length ?? 0) > 1);
</script>
